/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnjoins2Inputs */

const en_opportunitiescolumnjoins2 = /** @type {(inputs: Opportunitiescolumnjoins2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

const de_opportunitiescolumnjoins2 = /** @type {(inputs: Opportunitiescolumnjoins2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beigetreten`)
};

/**
* | output |
* | --- |
* | "Joined" |
*
* @param {Opportunitiescolumnjoins2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnjoins2 = /** @type {((inputs?: Opportunitiescolumnjoins2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnjoins2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnjoins2(inputs)
	return de_opportunitiescolumnjoins2(inputs)
});
export { opportunitiescolumnjoins2 as "opportunitiesColumnJoins" }